module.exports = __webpack_public_path__ + "img/seierstad_Bokhandleren_i_Kabul5.7b02d632.jpg";